import React from 'react'
import bgimg from '../../assets/image/bgimg.avif';
import bgimg2 from '../../assets/image/bgimg2.avif';
import { Herosection } from '../sections/Herosection';
import { About } from '../sections/About';
import Footer from '../footer/Footer';

export const Home = () => {
    return <>
        <div className="backdrop-blur-none overflow-hidden relative">
            <img className='h-100 w-full absolute -left-1/4 top-[60%] sm:top-[50%] md:top-[55%] lg:top-[45%] xl:top-[45%] scale-[7] sm:scale-[5] lg:scale-[2.5] pointer-events-none block dark:hidden -z-10 blur-2xl' src={bgimg2} alt="Light Mode Icon" />
            <img className='h-100 w-full absolute -left-1/4 top-[60%] sm:top-[50%] md:top-[55%] lg:top-[45%] xl:top-[40%] scale-[7] sm:scale-[5] lg:scale-[2.5] pointer-events-none dark:block hidden -z-10 blur-2xl rotate-[294deg]' src={bgimg} alt="Dark Mode Icon" />
            <Herosection />
            <About />
            <Footer />
        </div>
    </>;
}
